import React from 'react';
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { LoadingSpinner, Unauthorized, Wrapper } from '../../components';
import { GlobalSettings, useGlobalSettings } from "../../contexts";
import { LoadingSpinnerMeta } from "../../data";
import { Role } from "../../data/types";
import { useAuth } from "./AuthContext";

interface Props {
    allowAnonymous?: boolean;
    requiredRole?: Role | "any";
    requiredPermission?: string;
    requiredAnyPermission?: string[];
    checkSettings?: (settings: GlobalSettings) => boolean;
    noWrapper?: boolean;
}

export const ProtectedRoute: React.FC<Props> = (props) => {
    const { allowAnonymous = false, requiredRole = "any", requiredPermission, requiredAnyPermission, checkSettings, noWrapper = false } = props;
    const { isAuthenticated, user } = useAuth();
    const { settings, loading: settingsLoading } = useGlobalSettings();

    // Get current location for redirect after login
    const location = useLocation();

    if (!(allowAnonymous || isAuthenticated)) {
        return <Navigate to="/login" replace state={{ from: location.pathname }} />;
    }

    if (!user) {
        return noWrapper ? <Unauthorized /> : <Wrapper><Unauthorized /></Wrapper>;
    }

    if (requiredRole !== "any" && user.role !== requiredRole) {
        return noWrapper ? <Unauthorized /> : <Wrapper><Unauthorized /></Wrapper>;
    }

    if (requiredPermission && !user.permissions?.includes(requiredPermission)) {
        return noWrapper ? <Unauthorized /> : <Wrapper><Unauthorized /></Wrapper>;
    }

    if (requiredAnyPermission && !requiredAnyPermission.some(permission => user.permissions?.includes(permission))) {
        return noWrapper ? <Unauthorized /> : <Wrapper><Unauthorized /></Wrapper>;
    }

    if (checkSettings) {
        if (settingsLoading) {
            return <div className="flex items-center justify-center h-screen bg-gray-50 dark:bg-gray-900">
                <LoadingSpinner meta={LoadingSpinnerMeta} />
            </div>;
        }
        if (!checkSettings(settings)) {
            return noWrapper ? <Unauthorized /> : <Wrapper><Unauthorized /></Wrapper>;
        }
    }

    return noWrapper ? <Outlet /> : <Wrapper><Outlet /></Wrapper>
};
